// Behavioural port of AI SDK Elements' Sources (Apache-2.0, Copyright Vercel); anatomy only.

/** Where a source came from: the open web, or the brand's own knowledge library. */
type SourceKind = 'web' | 'knowledge'

export interface SourceEntry {
  kind: SourceKind
  /** A web source's URL, or a knowledge page's slug. */
  ref: string
  title?: string
  /** An image URL on our own storage; the kind's glyph shows when it is absent. */
  favicon?: string
}

export function sourceDomain(ref: string): string {
  try {
    return new URL(ref).hostname.replace(/^www\./, '')
  } catch {
    return ref
  }
}

/** The short name a source goes by in a chip: a web page's domain, a knowledge page's title. */
export function sourceChipName(source: SourceEntry): string {
  return source.kind === 'web' ? sourceDomain(source.ref) : (source.title ?? source.ref)
}
